







import { Component, Vue } from "vue-property-decorator";
import {logout, protocol, tokenlogin, wxjsapipay, ActivateJlReport} from "@/req/user";
import TitleHeader from "@/components/header.vue";
import checkBox from "@/views/Login/component/checkBox.vue";
import Burying from "@/utils/Buryingpoint"

@Component
export default class App extends Vue {
  public searchData: any = [];
  public password = "";
  public username = "";
  public code = "";
  public status = false;

  public created() {
    if(sessionStorage.getItem("box_token")) {
      this.box_login()
    }
    if (sessionStorage.getItem("game_name")) {
      (document as any).title = sessionStorage.getItem("game_name");
    } else {
      (document as any).title = "传奇世界";
    }
    if (this.isMobile()) {
      const ua: any = navigator.userAgent.toLowerCase();
      const isIosQQ = / QQ/i.test(navigator.userAgent);
      const isAndroidQQ =
        /MQQBrowser/i.test(navigator.userAgent) &&
        /QQ/i.test((navigator.userAgent as any).split("MQQBrowser"));
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        this.status = true;
        this.$store.dispatch("user/wx", true);
        let url = window.location.href
        var querys = url.substring(url.indexOf("?") + 1).split("&")
        var result = []
        for (var i = 0; i < querys.length; i++) {
          var temp = querys[i].split("=")
          if (temp.length < 2) {
            result[temp[0]] = ""
          } else {
            result[temp[0]] = temp[1]
          }
        }
        this.code = result["code"]
        if(this.code == null || this.code == ""){
          window.location.href='https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd05ae86ae4be4241&redirect_uri='+ url  +'&response_type=code&scope=snsapi_base&state=123#wechat_redirect';
          // https://sdk-dev.dhsf.xqhuyu.com/api/paywx/getopenid
        }else {
          this.getopenid()
        }
        // this.getopenid()
        return false;
      } else if (isIosQQ || isAndroidQQ) {
        this.status = true;
        return false;
      }
    }
    if (sessionStorage.getItem("logo")) {
      const link: any = document.createElement("link");
      link.rel = "shortcut icon";
      link.href = sessionStorage.getItem("logo");
      document.getElementsByTagName("head")[0].appendChild(link);
      const linkIos: any = document.createElement("link");
      linkIos.rel = "apple-touch-icon-precomposed";
      linkIos.href = sessionStorage.getItem("logo");
      document.getElementsByTagName("head")[0].appendChild(linkIos);
    }
    const screenWidth = window.screen.width;
    console.log('screenWidth', screenWidth)
    this.getUrl();
    this.jlreport();
    this.jh()
  }
  public async box_login () {
    // let obj = {token:sessionStorage.getItem("box_token"),game_id:sessionStorage.getItem("gameid")}
    const obj = {
      token: sessionStorage.getItem("box_token"),
      game_id: sessionStorage.getItem("gameid"),
    };
    const res = await tokenlogin(obj);
    if (res.code === 200) {
      this.$store.dispatch("user/authInfo", res.data);
      if (res.data.age_status === 2){
        this.$store.dispatch("user/authRouter", false);
      }
    } else {
      this.$store.dispatch("user/authRouter", false);
    }
  }
  public isMobile() {
    const flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    return flag;
  }

  // 判断屏幕是否旋转
  public orientationChange() {

  };
  public cutChange() {
    if (Number(sessionStorage.getItem("use_native_browser")) === 1) {
      return true;
    }
    return false;
  }
  public async getUrl() {
    const res = await protocol({});
    if (res.code === 200 && res.data.protocol) {
      return sessionStorage.setItem("protocol", res.data.protocol);
    }
    return sessionStorage.setItem("protocol", "0");
  }
  public async getopenid(){
    const obj: any = {
      code: this.code
      // code: '061Cky1w39YT4Z20UF1w3pVVlP3Cky1E'
    };
    const res = await wxjsapipay(obj);
    sessionStorage.setItem("openid",res.data.openid);
  }
  public async jlreport() {
    const objs: any = {
      // _device_info: JSON.stringify({adid:sessionStorage.getItem('adid'), creativeid:sessionStorage.getItem('creativeid'), creativetype:sessionStorage.getItem('creativetype'), clickid:sessionStorage.getItem('clickid'),type: 'h5'})
      _device_info: Burying.Escalation()
    }
    const res = await ActivateJlReport(objs);
    console.log(res)
  }
  public async jh() {
    let edata = {}
    edata.eventname = 'device_login'
    edata.eventtype = 'track'
    edata.uid = ''
    edata.properities = {
      resource: 'PC'
    }
    Burying.Burying(edata)
    if (this.$store.state.user.info.uid !== undefined) {
      let edata = {}
      edata.eventname = 'user_login'
      edata.eventtype = 'track'
      edata.uid = String(this.$store.state.user.info.uid)
      edata.properities = {}
      Burying.Burying(edata)
    }
  }
}
